import './spinner.scss';
import logo from 'src/assets/images/logo/logo.png';

const Spinner = () => {
    return (
        <div className='layout-box'>
            <img className='fallback-logo' src={logo} alt='logo' />
            <h5 className='title'>Initialising...</h5>
            <div className='loading'>
                <div className='effect-1 effects'></div>
                <div className='effect-2 effects'></div>
                <div className='effect-3 effects'></div>
            </div>
        </div>
    )
}

export default Spinner;
